import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// models
import { ApplicationSettings } from '../../../shared/models/application-settings';
import { GridProperty, Product, ProductProperty } from '../../../shared/models/product';

import { SupplierProduct } from '../models/supplier-product';

// interfaces
import { IProductService } from '../../../shared/interfaces/product';

// services
import { WebApiService } from '../../../shared/services/web-api.service';

@Injectable()
export class ProductService implements IProductService {

  private apiPath: string;

  private supplierId: number;

  setId(supplierId: number)
  {
    this.supplierId = supplierId;
  }

  constructor(private appSettings: ApplicationSettings, private webApiService: WebApiService) {
    this.apiPath = this.appSettings.adminApi + 'supplierlevel';
  }

  getProductSupplier(supplierId: number, auctionClusterId: number, productId: number): Observable<Product> {
    return this.webApiService.getSingle(`${this.apiPath}/${supplierId}/auctioncluster/${auctionClusterId}/product/${productId}`);
  }
  
  getProductsClocks(supplierId: number): Observable<Array<SupplierProduct>> {
    return this.webApiService.getList(this.apiPath + '/' + supplierId + '/product/clock');
  }

  getProducts(supplierId: number, auctionClusterId: number): Observable<Array<Product>> {
    return this.webApiService.getList(`${this.apiPath}/${supplierId}/auctioncluster/${auctionClusterId}/products`);
  }

  //IProductService

  getProductForReports(auctionClusterId: number, productId: number): Observable<Product> {
    return this.webApiService.getSingle(`${this.apiPath}/${this.supplierId}/auctioncluster/${auctionClusterId}/product/${productId}`);
  }

  getProductProperties(productId: number): Observable<Array<ProductProperty>> {
    return this.webApiService.getSingle(`${this.appSettings.adminApi}product/${productId}/productproperties`);
  }

  getReportProperties(productId: number, reportDesignId: number): Observable<Array<GridProperty>> {
    return this.webApiService.getSingle(`${this.appSettings.adminApi}product/${productId}/reportproperties/${reportDesignId}`);
  }

  getProduct(auctionClusterId: number, productId: number): Observable<Product> {
    return this.webApiService.getSingle(`${this.apiPath}/${this.supplierId}/auctioncluster/${auctionClusterId}/product/${productId}/supplyexpectation`);
  }
}
